export const generateSubTestId = (dataTestId: string | undefined, name: string) => (dataTestId ? `${dataTestId}-${name}` : '')
